import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import * as h from 'h'
import fastclick from 'fastclick'
import 'autotrack'

import App from './App'

import 'styles/global.scss'

if (process.env.NODE_ENV === 'production') {
  window.ga('create', process.env.GA_TRACKING_CODE, 'auto')
  window.ga('require', 'eventTracker')
  window.ga('require', 'outboundLinkTracker')
  window.ga('require', 'urlChangeTracker')
  window.ga('send', 'pageview')
}

// Set up fastclick
if (document && document.body) {
  fastclick.attach(document.body)
}

const render = Component => {
  ReactDOM.render(
    h.h(AppContainer, null, h.h(Component)),
    document.getElementById('root')
  )
}

render(App)

if (module.hot) {
  module.hot.accept('./App', () => { render(App) })
}



// WEBPACK FOOTER //
// ./resources/assets/js/index.js